<template>
  <container :class="['page-wrapper']">
    <flex :spacing="3">
      <flex-col :span="24">
        <test-toolbar>
          <checkbox label-size="xs" :icon-color="$root.$colors.primary" :label="$lang.multiple" :icon-color-lightness="$root.$colors.bgColorLightness" v-model="multiple" /><!--
          --><dropdown :class="['mr-1']" v-model="expand" :title="$lang.testTheExpandProp" :items="expands" width="128px" :ripple-color="$dark ? 'white' : 'gray'" :ripple-color-lightness="$dark ? null : 300" :color="$root.$colors.primary" :color-lightness="$root.$colors.bgColorLightness" />
        </test-toolbar>
      </flex-col>
      <flex-col :span="24">
        <app-release-notes
          :key="key"
          :notes="notes"
          :multiple="multiple"
          :reverse="reverse"
          :expand="expand[0]"
          :color="$dark ? 'white' : 'black'"
          :color-lightness="null"
          :color-expanded="$dark ? 'white' : 'black'"
          :color-lightness-expanded="null"
          bg-color-expanded="grey"
          :bg-color-lightness-expanded="$dark ? 900 : 200"
          bg-color="transparent"
          :bg-color-lightness="null">
          <template v-slot:note="slotProps">
            <card :class="['m-2']">
              <card-text padding-off>
                <list>
                  <list-item tag="router-link" :title="note.title" :to="note.path" v-for="(note, index) in slotProps.notes" :key="index">
                    <list-item-avatar>
                      <icon :name="note.icon" :color="$root.colors.primary" :color-lightness="$root.colors.bgColorLightness" />
                    </list-item-avatar>
                    <list-item-content>
                      <list-item-content-title v-html="`${$lang.released} ${note.title} ${$lang.component.toLowerCase()}`" />
                      <list-item-content-sub-title v-html="note.name.replace('page-', '')" />
                    </list-item-content>
                    <list-item-icon>
                      <icon name="chevron-double-right" />
                    </list-item-icon>
                  </list-item>
                </list>
              </card-text>
            </card>
          </template>
        </app-release-notes>
      </flex-col>
    </flex>
  </container>
</template>
<script>
import methods from '../../mixins/methods'

export default {
  name: 'PageAppReleaseNotes',
  mixins: [
    methods
  ],
  data () {
    return {
      key: 0,
      reverse: true,
      multiple: false,
      expand: ['none'],
      expands: ['first', 'last', 'none', 'all'].map(value => {
        return {
          value,
          text: this.firstLetterCapital(value)
        }
      })
    }
  },
  watch: {
    $dark () {
      this.key++
    },
    expand () {
      this.key++
    },
    multiple () {
      this.key++
    },
    reverse () {
      this.key++
    }
  },
  computed: {
    notes () {
      const length = 6
      const items = this.getNavigationSection('ui')
      return Array.from(Array(length).keys()).map(index => {
        return {
          title: `v1.0.${index}`,
          notes: items.splice(index + 1, 5)
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/content/app-release-notes.vue